import React from 'react';
import BrandContent from './content';
import { BrandProvider } from 'contexts/brand.context';

const BrandLayout = () => {
  return (
    <BrandProvider>
      <BrandContent />
    </BrandProvider>
  );
};

export default BrandLayout;
